module.exports = __webpack_public_path__ + "static/media/img3-3.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/nutricheck_foliar/P/img3-3.png
// module id = 2071
// module chunks = 3